// @ts-expect-error: Flow to TS migration.
import Polyglot from "kiwi-polyglot"
import * as R from "ramda"

import capitalize from "../../utils/capitalize"
import startCase from "../../utils/startCase"
import upperFirst from "../../utils/upperFirst"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
type Processors = {
  [key: string]: (val: string) => string
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
type Values = {
  [key: string]: string
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
export type Translations = {
  [key: string]: string
}

type Options = {
  translations?: Translations
  process?: string | string[]
  language?: string
  defaultShow?: string
}

const getProcessors = (): Processors => ({
  linify: (input) => input.replace(/\n/g, "<br />"),
  addClassToLinks: (input) => input.replace(/<a /g, '<a class="spTypoLink" target="_blank" '),
  firstCharUp: capitalize,
  uppercase: R.toUpper,
  lowercase: R.toLower,
  startCase,
  capitalizeFirstChar: upperFirst,
})

export default function pureTranslate(
  key: string,
  values: Values = {},
  options: Options = {},
): string {
  // Normalize args
  // ---
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const translations = options.translations || {}

  const fallback = R.is(String, options.defaultShow) ? options.defaultShow : key

  // Polyglot expects placeholders to be in the old __placeholder__ format, not in the new {placeholder} format
  // eslint-disable-next-line prefer-named-capture-group
  const translated = (translations[key] || fallback).replace(/\{(\w+)\}/g, "__$1__")
  const text = Polyglot.transformPhrase(translated, values, options.language)

  const processors = getProcessors()
  // Process
  // ---
  if (Array.isArray(options.process)) {
    return options.process.reduce((result, funcName) => processors[funcName](result), text)
  }

  if (R.is(String, options.process)) {
    return processors[options.process](text)
  }

  return text
}
